// src/components/Apm/Term/ContractTerms.js

import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useMediaQuery, useTheme } from '@mui/material';

import { getItems } from '../../../redux/slices/contractTermSlice';
import { columnsContractTerms } from '../Tables/Columns/columnsContractTerms';
import TableSimple from '../Tables/TableSimple';

const MOBILE_COLUMN_IDS = new Set(['term_short', 'term_description']);

const ContractTerms = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const theme = useTheme();

  const smMediaDown = useMediaQuery(theme.breakpoints.down('sm'));

  const { contractTerms = [], statusContractTerms = null } = useSelector((state) => state.contractTermSlice ?? {});

  useEffect(() => {
    if (contractTerms.length === 0 && statusContractTerms === null) {
      dispatch(getItems());
    }
  }, [contractTerms.length, dispatch, statusContractTerms]);

  const updatedColumns = useMemo(() => {
    const columns = columnsContractTerms();

    if (!smMediaDown) {
      return columns;
    }

    return columns.filter((column) => MOBILE_COLUMN_IDS.has(column.id));
  }, [smMediaDown]);

  return (
    <TableSimple
      resource="terms"
      columns={updatedColumns}
      data={contractTerms}
      popupTitle={t('popup.title.invoice_terms')}
      addButtonText={t('button.add_invoice_terms')}
    />
  );
};

export default ContractTerms;
